import { ADD_PURCHASE_BILL, ADD_PURCHASE_RETURN, ADD_SALE_BILL, addPurchaseBill, CAL_PURCHASE_BILL, DELETE_PURCHASE_BILL, DELETE_PURCHASE_RETURN, DELETE_SALE_BILL, GET_PURCHASE_BILL, GET_PURCHASE_RETURN, GET_SALE_BILL, PURCHASE_PURCHASE_BILL, UPDATE_PURCHASE_RETURN, UPDATE_SALE_BILL, VIEW_PURCHASE_BILL, VIEW_PURCHASE_RETURN, VIEW_SALE_BILL } from "../actions/Billing.action";

const initialState = {
    addPurchaseBill: '',
    calPurchaseBill: '',
    getPurchaseBill: '',
    deletePurchaseBill: '',
    viewPurchaseBill: '',
    updatePurchaseBill: '',
    addSaleBill: '',
    getSaleBill: '',
    deleteSaleBill: '',
    viewSaleBill: '',
    updateSaleBill: '',
    addpurchaseReturn: '',
    getpurchaseReturn: '',
    updatepurchaseReturn: '',
    deletepurchaseReturn: '',
    viewpurchaseReturn: '',
}

const billReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PURCHASE_BILL:
            return { ...state, addPurchaseBill: action.payload };
        case CAL_PURCHASE_BILL:
            return { ...state, calPurchaseBill: action.payload };
        case GET_PURCHASE_BILL:
            return { ...state, getPurchaseBill: action.payload };
        case DELETE_PURCHASE_BILL:
            return { ...state, deletePurchaseBill: action.payload };
        case VIEW_PURCHASE_BILL:
            return { ...state, viewPurchaseBill: action.payload };
        case PURCHASE_PURCHASE_BILL:
            return { ...state, updatePurchaseBill: action.payload };
        case ADD_SALE_BILL:
            return { ...state, addSaleBill: action.payload };
        case GET_SALE_BILL:
            return { ...state, getSaleBill: action.payload };
        case DELETE_SALE_BILL:
            return { ...state, deleteSaleBill: action.payload };
        case VIEW_SALE_BILL:
            return { ...state, viewSaleBill: action.payload };
        case UPDATE_SALE_BILL:
            return { ...state, updateSaleBill: action.payload };
        case ADD_PURCHASE_RETURN:
            return { ...state, addPurchaseBill: action.payload };
        case GET_PURCHASE_RETURN:
            return { ...state, getpurchaseReturn: action.payload };
        case UPDATE_PURCHASE_RETURN:
            return { ...state, updatepurchaseReturn: action.payload };
        case DELETE_PURCHASE_RETURN:
            return { ...state, deletepurchaseReturn: action.payload };
        case VIEW_PURCHASE_RETURN:
            return { ...state, viewpurchaseReturn: action.payload };
        default:
            return state;
    }
}

export default billReducer;